module.exports = __webpack_public_path__ + "img/stock6.42a67756.png";